import React from "react";
import classnames from "classnames";

const SuggestedCvid = (WrappedComponent) => (props) => {
    const cvidSuggestions = props.suggestions.map((cvid, index) => {
        return (
            <li key={`cvid_suggestions_${index}`}>
                <button
                    key={`cvid_${index}`}
                    disabled={props.disabled}
                    className={classnames("button -text ", {
                        "-selected": props.value === cvid,
                    })}
                    onClick={() => {
                        props.updateOnChange(props.name, cvid);
                    }}
                >
                    {cvid}
                </button>
            </li>
        );
    });

    return (
        <div className="suggestion-wrapper">
            <WrappedComponent {...props} />
            <ul className="suggestion-list">{cvidSuggestions}</ul>
        </div>
    );
};

export default SuggestedCvid;
